export default __webpack_public_path__ + "static/media/NOVDOM2024.f5606aa6.png";